import { useLocation, useNavigate } from 'react-router-dom';
import { LuLogOut, LuUser } from 'react-icons/lu';
import { Menu } from '../ui/Menu';
import { Avatar } from '../ui/Labels';
import { useStrings } from '../tenant/TenantProvider';
import { useAuthStore } from '../stores/auth';
import { useSignOut } from './useSignOut';
import { cx } from '../ui/cx';

export function UserMenu() {
  const t = useStrings();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const user = useAuthStore((state) => state.user);
  const signOut = useSignOut();
  const onProfile = pathname === '/profile' || pathname.startsWith('/profile/');

  return (
    <Menu
      trigger={(props) => (
        <button type="button" className={cx('user-menu__trigger', onProfile && 'is-active')} aria-label={t('nav.accountMenu')} {...props}>
          <Avatar name={user?.username} />
        </button>
      )}
    >
      <div className="menu__header">
        <p className="menu__title">{user?.username}</p>
        <p className="menu__subtitle">{user?.email}</p>
      </div>
      <button type="button" role="menuitem" className="menu__item" onClick={() => navigate('/profile', { viewTransition: true })}>
        <LuUser aria-hidden="true" />
        {t('nav.profile')}
      </button>
      <div className="menu__separator" role="separator" />
      <button type="button" role="menuitem" className="menu__item" onClick={signOut}>
        <LuLogOut aria-hidden="true" />
        {t('nav.signOut')}
      </button>
    </Menu>
  );
}
